import React from 'react';

import { FormField, Label } from '@zillow/constellation';

import type { Section } from '../../../models/index';
import { SPRINGFIELD_ZONING_REQUIREMENTS } from '../../../constants';
import YesAndNo from '../../Widgets/YesAndNo';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function SpringfieldZoningRequirements({ section, setSectionValues }: Props) {
  function onPropertyYes(): void {
    setSectionValues({
      [SPRINGFIELD_ZONING_REQUIREMENTS.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  function onPropertyNo(): void {
    setSectionValues({
      [SPRINGFIELD_ZONING_REQUIREMENTS.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  const onProperty = section.getFieldValue(SPRINGFIELD_ZONING_REQUIREMENTS.FIELD_NAME.IS_ENABLED);

  return (
    <FormField
      label={
        <Label size="lg">
          Is your property in the Rountree Urban Conservation District or the Phelps Grove Neighborhood Area?
        </Label>
      }
      control={<YesAndNo yesHandler={onPropertyYes} noHandler={onPropertyNo} yesActive={onProperty} />}
    />
  );
}
